import { buildSearchGraphQLQuery } from '@/components/ProspectSearch/searchUtils';
import { GraphQLQuery } from '@lambda-layer/types/filter';

/**
 * Build a GraphQL query for your quick search
 * that searches across the specified columns.
 */
export function buildQuickSearchGraphQLQuery<T>(
  searchString: string,
  searchFields: (keyof T)[]
): GraphQLQuery<T> {
  if (!searchString) {
    return {};
  }
  return buildSearchGraphQLQuery<T>(searchString, searchFields);
}
